// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


const wc_cart_fragments_params = window.wc_cart_fragments_params;






export default {

    removeItem: function(url) {
        return $.ajax( {
                type:     'GET',
                url:      url,
                dataType: 'html',
            } );
    },

    addItem: function(data) {
        return $.ajax( {
            url: wc_cart_fragments_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
            type: 'POST',
            data: data
        } );
    }

};